module.exports = __webpack_public_path__ + "headphones.svg?1bf43abc20945a28775d5021b7a62a4c";